import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-rfi-analysis-info-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
  templateUrl: './rfi-analysis-info-button.component.html',
})
export class RfiAnalysisInfoButtonComponent {
  readonly testId = input.required<string>();

  readonly clicked = output<void>();
}
